import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/terms/page.tsx");
